module.exports = __webpack_public_path__ + "icons/original/large/large-f1.2d3e9386d0328114e71184f6946f14b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-f1.png
// module id = ZNit
// module chunks = app